import React, { Component } from "react";
import CssClasses from "./LiveEventList.css";
import EventGroupItemLiveFootball from "../../Components/EventGroupItemLiveFootball/EventGroupItemLiveFootball";
import EventGroupItemLiveGeneric from "../../Components/EventGroupItemLiveGeneric/EventGroupItemLiveGeneric";
import { connect } from "react-redux";
import * as LocalStorageKeys from "../../HOCs/Constants/LocalStorageKeys";
import * as StoreActions from "../../ReduxStore/Actions/ActionIndex";
import * as BetRadarServices from "../../Communication/BetRadarServicesHandler";

let lastChosenSvoID = "";
let lastExpanded = 0;

class LiveEventList extends Component {
  storageHandler = event => {
    //console.log("Storage event for key: ", event.key);
    if (event.key === LocalStorageKeys.LOCALSTORAGE_TICKET_ITEMS) {
      //pozovi event
      this.ticketItemStateChangedHandler();
    }
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    //pogledaj je li se promjenio property
    if (prevProps.currentLanguage !== this.props.currentLanguage) {
      // Do whatever you want
      //console.log("LANG CHANGED!");
      this.handleLanguageChange(this.props.currentLanguage);
    } else {
      //console.log("LANG NOT CHANGED!");
    }

    if (prevProps.liveExtraBetsID !== this.props.liveExtraBetsID) {
      // Do whatever you want
      if (this.props.liveExtraBetsID > 0) {
        console.log("------------> PROMJENA EXTRABETS!");
        this.refreshThirdSetData();
      }
    } else {
      //console.log("LANG NOT CHANGED!");
    }

    if (prevProps.currentBetGroups !== this.props.currentBetGroups) {
      // Do whatever you want
      console.log("------------> PROMJENA GRUPA!");
      this.refreshThirdSetData();
    } else {
      //console.log("LANG NOT CHANGED!");
    }

    //updateaj i meceve info
    if (prevProps.updateStampOData !== this.props.updateStampOData) {
      //nove tekme info!
      //console.log("NEW MATCHES INFO!");
      this.props.updateTicketItems(this.props.liveMatchesList);
    }
  }

  handleLanguageChange = newLangCode => {
    //ponovno okini get initial set
    //make axios call
    BetRadarServices.getInitialSetData(newLangCode, this.processInitialSetData);
  };

  ticketItemStateChangedHandler = () => {
    //dohvati iz storagea
    var ticketInfo = JSON.parse(
      localStorage.getItem(LocalStorageKeys.LOCALSTORAGE_TICKET_ITEMS)
    );

    console.log("LIVE: Received ticket items from LocalStorage! " + new Date());

    //i spremi u state
    this.props.onRestoreTicketStateFromLocalStorage(ticketInfo);
  };

  componentWillMount() {
    //pretplati se na promjenu
    window.addEventListener("storage", this.storageHandler, false);
  }

  componentDidMount() {
    console.log("FETCHING DATA FROM SERVER...");

    //Loading
    this.props.startLoading(false, false);

    //make axios call
    BetRadarServices.getInitialSetData(
      this.props.currentLanguage,
      this.processInitialSetData
    );
  }

  processInitialSetData = val => {
    console.log("RECEIVED DATA IN CALLBACK: ", val);

    if (val === null || val === undefined) {
      //return zasad, handle error later
      return;
    }

    //dohvati od bitnih podataka sto trebas i spremaj u redux state
    let dataSet = val.InitialSetPartitionedResult;

    this.props.setInitialSetValues(dataSet);

    //gasi laoding
    this.props.stopLoading(false);

    //napravi interval za third set
    setInterval(() => {
      //usporedi
      // console.log("STATE BET GROUPS: ", this.props.currentBetGroups);

      // if (this.props.currentBetGroups !== lastChosenSvoID) {
      //   console.log("CHANGE!");
      // } else {
      //   console.log("NO CHANGE!");
      // }

      this.refreshThirdSetData();
    }, 3000);
  };

  refreshThirdSetData = () => {
    //console.log("REFRESHING DATA..." + new Date());
    //console.log("EXTRABESTID ..." + this.props.liveExtraBetsID);

    BetRadarServices.getThirdSetData(
      this.processThirdPartitionedSetData,
      ",",
      this.props.currentBetGroups === lastChosenSvoID
        ? this.props.currentBetGroups
        : "",
      this.props.currentLanguage,
      this.props.updateStampKData,
      this.props.updateStampOData,
      this.props.updateStampUData,
      this.props.updateStampUText,
      this.props.liveExtraBetsID !== lastExpanded
        ? this.props.liveExtraBetsID
        : 0,
      this.props.currentBetGroups !== lastChosenSvoID
        ? this.props.currentBetGroups
        : "",
      this.props.liveExtraBetsID === lastExpanded
        ? this.props.liveExtraBetsID
        : 0
    );

    //prikaci u old
    lastChosenSvoID = this.props.currentBetGroups;
    lastExpanded = this.props.liveExtraBetsID;
  };

  processThirdPartitionedSetData = val => {
    //console.log("RECEIVED DATA IN CALLBACK: ", val);

    if (val !== null && val !== undefined) {
      //dohvati od bitnih podataka sto trebas i spremaj u redux state
      let dataSet = val.ThirdSetPartitionedResult;

      this.props.setThirdPartitionedSetValues(dataSet);
    }
  };

  render() {
    //console.log("LIVEVENTLIST MATCHES: ", this.props.liveMatchesList);

    if (
      this.props.liveMatchesList === undefined ||
      this.props.liveMatchesList === null
    ) {
      return null;
    }

    let currentSportID = this.props.currentLiveSportID;

    //provjeri da postoji sport taj
    var sport = this.props.sportInfo.find(
      x => x.sportID === this.props.currentLiveSportID
    );

    // console.log("SPORT IS ", sport);
    // console.log("SPORT ID IS ", this.props.currentLiveSportID);

    if (!sport) {
      //odaberi prvog u listi
      let activeInfo = this.props.livePickerInfo;

      if (activeInfo !== null && activeInfo.length > 0) {
        //sortiraj
        activeInfo.sort((a, b) => {
          return a.UIOrderIndex - b.UIOrderIndex;
        });

        //oznaci prvoga
        this.props.onChangeSportLive(activeInfo[0].sportID);
      }
    }

    //filtriraj iteme
    let filteredItems = this.props.liveMatchesList.filter(
      x => x.sportID === currentSportID
    );

    //ako nema matcheva, daj prvi iduci
    if (filteredItems.length === 0) {
      //povecaj id
      currentSportID++;

      //idi u listu sportova i vidi iduci prvi
    }

    let containerClasses = [CssClasses.container];

    //console.log("EXTRABETSID ", this.props.liveExtraBetsID);

    if (this.props.liveExtraBetsID > 0 || this.props.isShowingBonusInfo) {
      containerClasses.push(CssClasses.showsExtraBets);
    } else {
      if (this.props.shouldQuickCloseExtraBets) {
        containerClasses.push(CssClasses.quickHidesExtraBets);
      } else {
        containerClasses.push(CssClasses.hidesExtraBets);
      }
    }

    //i header buttons
    let headerButtons = this.props.allBetsText.filter(
      x => x.SportID === currentSportID && x.HederOklada === 1
    );

    if (currentSportID === 1) {
      //soccer
      return (
        <div className={containerClasses.join(" ")}>
          <EventGroupItemLiveFootball
            key={1}
            matches={filteredItems}
            currentSportID={currentSportID}
            isLiveGroupItem={true}
            headerButtons={headerButtons}
            refreshDataCallback={() => this.refreshThirdSetData()}
          />
        </div>
      );
    } else {
      //ostalo
      return (
        <div className={containerClasses.join(" ")}>
          <EventGroupItemLiveGeneric
            key={1}
            matches={filteredItems}
            currentSportID={currentSportID}
            isLiveGroupItem={true}
            headerButtons={headerButtons}
            refreshDataCallback={() => this.refreshThirdSetData()}
          />
        </div>
      );
    }

    // return (

    //   //modifikij ako ce trebat vise njih

    //   // <div className={containerClasses.join(" ")}>
    //   //   {filteredItems.map(eventInfo => {
    //   //     if (eventInfo.sportID === 1) {
    //   //       //soccer
    //   //       return (
    //   //         <EventGroupItemLiveFootball
    //   //           key={eventInfo.id}
    //   //           eventInfo={eventInfo}
    //   //           currentSportID={this.props.currentLiveSportID}
    //   //           isLiveGroupItem={true}
    //   //         />
    //   //       );
    //   //     } else {
    //   //       return (
    //   //         <EventGroupItemLiveGeneric
    //   //           key={eventInfo.id}
    //   //           eventInfo={eventInfo}
    //   //           currentSportID={this.props.currentLiveSportID}
    //   //           isLiveGroupItem={true}
    //   //         />
    //   //       );
    //   //     }
    //   //   })}
    //   // </div>

    // );
  }
}

const mapStateToProps = state => {
  return {
    currentLiveSportID: state.rrNavigation.liveSportID,
    currentBetGroups: state.rrNavigation.activeBetGroups,
    liveExtraBetsID: state.rrNavigation.liveExtraBetsID,
    initialSetValues: state.rrSportEvent.initialLiveSetInfo,
    liveMatchesList: state.rrSportEvent.liveMatchesList,
    livePickerInfo: state.rrSportEvent.activeLiveSports,
    ticketPairInfo: state.rrTicket.ticketPairInfo,
    allBetsText: state.rrSportEvent.allBetsText,
    currentLanguage: state.rrAppState.currentLanguage,
    updateStampKData: state.rrSportEvent.updateStampKData,
    updateStampOData: state.rrSportEvent.updateStampOData,
    updateStampOText: state.rrSportEvent.updateStampOText,
    updateStampUData: state.rrSportEvent.updateStampUData,
    updateStampUText: state.rrSportEvent.updateStampUText,
    shouldQuickCloseExtraBets: state.rrNavigation.shouldQuickCloseExtraBets,
    isShowingBonusInfo: state.rrNavigation.isShowingBonusInfo,
    sportInfo: state.rrSportEvent.activeLiveSports
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onRestoreTicketStateFromLocalStorage: ticketState =>
      dispatch(StoreActions.RestoreTicketStateFromLocalStorage(ticketState)),
    setInitialSetValues: setValues =>
      dispatch(StoreActions.SetInitialSet(setValues)),
    setThirdPartitionedSetValues: setValues =>
      dispatch(StoreActions.SetThirdPartitionedSet(setValues)),
    startLoading: (isTransparent, updateLocalStorage) =>
      dispatch(StoreActions.StartLoading(isTransparent, updateLocalStorage)),
    stopLoading: updateLocalStorage =>
      dispatch(StoreActions.StopLoading(updateLocalStorage)),
    updateTicketItems: updatedMatches =>
      dispatch(StoreActions.UpdateTicketCoefs(updatedMatches)),
    onChangeSportLive: sportID =>
      dispatch(StoreActions.ChangeSportLive(sportID))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveEventList);



// WEBPACK FOOTER //
// ./src/Containers/LiveEventList/LiveEventList.js